import React from "react";
import gsap from "gsap";
import { useNavigate } from "react-router-dom";
import { isMobile } from "detect-touch-device";
import LocomotiveScroll from "locomotive-scroll";
import setBodyColor from "./SetBodyColor";
import setSocialDisplay from "./SetSocialDisplay";
import setSocialPosition from "./SetSocialPosition";

import logoMercedes from "../images/logos/mercedes.png";
import logoNescafe from "../images/logos/nescafe.png";
import logoColgate from "../images/logos/colgate.png";
import logoMilOcho from "../images/logos/1800.png";
import logoHolcim from "../images/logos/holcim.png";
import logoChevrolet from "../images/logos/chevrolet.png";
import logoHP from "../images/logos/hp.png";
import logoBanana from "../images/logos/banana.png";
import logoPepsico from "../images/logos/pepsico.png";
import logoNike from "../images/logos/nike.png";

let aeromexico = "https://yeahpure.s3.us-east-2.amazonaws.com/aeromexico.png";
let atandt = "https://yeahpure.s3.us-east-2.amazonaws.com/att.png";
let cocacola = "https://yeahpure.s3.us-east-2.amazonaws.com/cocacola.png";
let comex = "https://yeahpure.s3.us-east-2.amazonaws.com/comex.png";
let google = "https://yeahpure.s3.us-east-2.amazonaws.com/google.png";
let spotify = "https://yeahpure.s3.us-east-2.amazonaws.com/spotify.png";
let uber = "https://yeahpure.s3.us-east-2.amazonaws.com/uber.png";
let shorts = "https://yeahpure.s3.us-east-2.amazonaws.com/shorts.png";
let hagen = "https://yeahpure.s3.us-east-2.amazonaws.com/haagen.png";
let pizzahut = "https://yeahpure.s3.us-east-2.amazonaws.com/pizzahut.png";
let victoria = "https://yeahpure.s3.us-east-2.amazonaws.com/victoria.png";
let lenovo = "https://yeahpure.s3.us-east-2.amazonaws.com/lenovo.png";
let motorola = "https://yeahpure.s3.us-east-2.amazonaws.com/motorola.png";
let nokia = "https://yeahpure.s3.us-east-2.amazonaws.com/nokia.png";
let volvo = "https://yeahpure.s3.us-east-2.amazonaws.com/volvo.png";
let ubereats = "https://yeahpure.s3.us-east-2.amazonaws.com/ubereats.png";
let miniso = "https://yeahpure.s3.us-east-2.amazonaws.com/miniso.png";
let pedigree = "https://yeahpure.s3.us-east-2.amazonaws.com/pedigree.png";
let timeout = "https://yeahpure.s3.us-east-2.amazonaws.com/timeout.png";
let pringles = "https://yeahpure.s3.us-east-2.amazonaws.com/pringles.png";
let trevor = "https://yeahpure.s3.us-east-2.amazonaws.com/trevor.png";
let duolingo = "https://yeahpure.s3.us-east-2.amazonaws.com/duolingo.png";
let chilango = "https://yeahpure.s3.us-east-2.amazonaws.com/chilango.png";
let cielito = "https://yeahpure.s3.us-east-2.amazonaws.com/cielito.png";
let chilinbalam = "https://yeahpure.s3.us-east-2.amazonaws.com/chilinbalam.png";

class Partners extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  componentDidUpdate() {};

  onResize = (event) => {};

  render() {
    const { navigation } = this.props;
    return (
      <>
        <div className="container">
          <div className="row">             
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={comex}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoMercedes}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoNescafe}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={cocacola}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoColgate}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoMilOcho}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoPepsico}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoHolcim}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoChevrolet}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoBanana}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoHP}></img>
            </div>
            <div className="col-md-2 col-sm-4 col-4 partner-img">
              <img src={logoNike}></img>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default function (props) {
  const navigation = useNavigate();
  return <Partners {...props} navigation={navigation} />;
}
